import UnitAchDebit from 'core/components/unit/UnitAchDebit'
import { useSettings } from 'core/hooks/settings/useSettings'

const AchDebit = () => {
  const {
    data: { mfa }
  } = useSettings()
  const { accountId, customerToken } = mfa

  return (
    <UnitAchDebit
      account-id={accountId as string}
      customer-token={customerToken}
    />
  )
}

export default AchDebit
